/** FTO Pro 首页首次引导的页面状态读取函数。 */
export interface FtoProOnboardingStartOptions {
    /** 获取当前输入框内容。 */
    getInputValue: () => string;
    /** 获取当前非空输入是否来源于 URL 预填文本参数。 */
    getHasPrefilledInput: () => boolean;
    /** 获取页面是否正在根据 URL 自动运行。 */
    getIsAutoRunning: () => boolean;
}

/** FTO Pro 首页首次引导 service。 */
export interface FtoProOnboardingService {
    /** 按当前输入状态和公共账号资格尝试启动首次引导。 */
    start(options: FtoProOnboardingStartOptions): Promise<boolean>;
    /** 通知用户已聚焦 FTO 输入框。 */
    notifyInputFocused(): void;
    /** 通知用户通过示例填充了输入框。 */
    notifyExampleSelected(): void;
    /** 通知用户进行了手动输入。 */
    notifyManualInput(value: string): void;
    /** 消费一次提交按钮引导归因。 */
    consumeSubmitGuide(): boolean;
    /** 清理当前 FTO 首页引导的全部资源。 */
    destroy(): void;
}

/** FTO Pro 首页首次引导 service 的容器标识。 */
export const FtoProOnboardingService = Symbol('FtoProOnboardingService');
